module.exports = __webpack_public_path__ + "static/assets/8c72b45eaafa254580a22575fb541bc0.png";